export const presseTableFields = [
  { key: 'createdDatetime', label: 'Datum' },
  { key: 'filename', label: 'Dateiname', class: 'text-center' },
  { key: 'url', label: 'Link / Download' },
  { key: 'information', label: 'Information' },
  { key: 'function', label: 'function', class: 'text-center function' },
];